module.exports = __webpack_public_path__ + "static/media/1021103.18b37075.png";